import RegionTools from 'utils/regions/regionTools'
import geoJSON from 'utils/geoJSON/geoJSON'

const formatMapSeries = ({ regionsData, fn }) => {
  let chartData = regionsData.map(region => {
    let name = region.name
    let code = region.code
    let eventClick = () => fn(region)
    let countryCode = RegionTools.getCountryCodeFromRegionCode(code)
    let countryName = RegionTools.countryCodeToFullName(countryCode)
    return {
      name,
      code,
      countryName,
      events: {
        click: eventClick
      }
    }
  })

  let series = [
    {
      type: 'map',
      index: 1,
      mapData: geoJSON.regionLevel,
      data: chartData,
      joinBy: ['NUTS_ID', 'code'],
      color: '#E9F2F4',
      cursor: 'pointer',
      states: {
        hover: {
          color: '#0fa4c4'
        }
      }
    },
    {
      type: 'mapline',
      index: 2,
      mapData: geoJSON.countryLevel,
      nullColor: '#333',
      showInLegend: false,
      includeInCSVExport: false,
      name: 'borders',
      lineWidth: 0.75,
      color: '#CCCCCC',
      dataLabels: {
        enabled: false
      },
      states: {
        hover: {
          enabled: false
        }
      }
    }
  ]

  return series
}

const mapChartAdapter = {
  formatMapSeries
}
export default mapChartAdapter



// WEBPACK FOOTER //
// ./src/modules/Charts/Map/HomeMap/HomeMapAdapter.js